import { Modal } from "react-bootstrap";
import GradientButton from "./GradientButton";

export default function AlertModal({ modal }) {

    return(
            <Modal show={ modal.show } size="lg">
                <Modal.Header>
                    <h3>
                        { modal.title ? modal.title : modal.success ? "Success" : "Error" }
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    { modal.message && (typeof modal.message === "string" ? <p>{ modal.message }</p> : modal.message) }
                </Modal.Body>
                <Modal.Footer>
                    <GradientButton title="Close" variant="greenYellow" onClick={ modal.onClose } />
                </Modal.Footer>
            </Modal>
    )
}